import axios from "axios";
import services from "@/config/services";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";
import store from "@/store";
import moment from "moment";

export default class CaricamentoService {
  constructor(eventBus) {
    this.eventBus = eventBus;
    this.baseUrl = `${services.ask_pratiche.url}`;
    this.praticheUrl = `${services.ask_pratiche_base.url}`;
    this.baseUrlApi = `${services.ask_api.url}`;
    this.baseUrlFlussi = `${services.ask_flussi_api.url}`;
    this.baseUrlScraper = `${services.ask_pratiche_scraper.url}`;
    this.filemanager = new FileManager();
    axios.interceptors.request.use((req) => {
      req.headers["Authorization"] = authHeader();
      req.headers["Params"] =
        Cookies.get("google_access_token") || Cookies.get("ask_access_token");
      // this.eventBus.emit('data-loading');
      return req;
    });
  }

  async getCtrsComputed() {
    let items = {};
    const url = `${this.baseUrl}/get-ctrs-computed`;

    try {
      let res = await axios.get(url);
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async getLogsFileElaborazioneAskFile(type) {
    let items = {};
    const url = `${this.baseUrl}/process/agf/file/logs`;
    try {
      const res = await axios.post(url, { type });
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async getUploadedFilesUploadRcu() {
    let url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getUploadedFilesUploadRcu`;
    let res = await axios.get(url);
    return res.data;
  }

  async uploadFileRcuOnFtp(file) {
    let url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/uploadFileRcu`;
    let fd = new FormData();
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }
    fd.append("email", store.state.auth.user.email);
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async getAllUploadedFilesRcu() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFilesRcu`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async uploadFileSwitchOutOnFtp(files, subdirectory) {
    let url = `${this.praticheUrl}/api/switch-management/save/switchout`;
    let fd = new FormData();
    for (let i = 0; i < files.length; i++) {
      fd.append("files[]", files[i]);
    }
    fd.append("email", store.state.auth.user.email);
    if (subdirectory) {
      fd.append("subdirectory", subdirectory);
    }
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async downloadFileSospensioniERiattivazioni(filename, subdirectory) {
    const url = `${this.praticheUrl}/api/sospensioni-riattivazioni-management/download/sosp-riat/file`;
    const fd = new FormData();
    fd.append("filename", filename);
    fd.append("subdirectory", subdirectory);
  
    return axios.post(url, fd, {
      responseType: "blob",
    });
  }  

   async downloadAnnullamenti(filename) {
    const url = `${this.praticheUrl}/api/switch-management/download/annullamenti/file`;
    const fd = new FormData();
    fd.append("filename", filename);
  
    return axios.post(url, fd, {
      responseType: "blob",
    });
  }  

  async downloadVt4(filename) {
    const url = `${this.praticheUrl}/api/switch-management/download/vt4/file`;
    const fd = new FormData();
    fd.append("filename", filename);
  
    return axios.post(url, fd, {
      responseType: "blob",
    });
  }

  async downloadSwitchout(filename, supplyType) {
    const url = `${this.praticheUrl}/api/switch-management/download/switchout/file`;
    const fd = new FormData();
    fd.append("filename", filename);
    fd.append("supply-type", supplyType);
  
    return axios.post(url, fd, {
      responseType: "blob",
    });
  }

  async getAllUploadedFilesSwitchOut() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFilesSwitchOut`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async uploadFileSwitchInOnFtp(files, subdirectory) {
    // let url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/uploadFileSwitchIn`;
    let url = `${this.praticheUrl}/api/switch-management/handle/switchin-file`;
    let fd = new FormData();
    for (let i = 0; i < files.length; i++) {
      fd.append("files[]", files[i]);
    }
    fd.append("email", store.state.auth.user.email);
    if (subdirectory) {
      fd.append("subdirectory", subdirectory);
    }
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async getAllUploadedFilesSwitchIn() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFilesSwitchIn`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async getSubDirectorySwitchIn() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getSubDirectorySwitchIn`;
      const response = await axios.get(url);

      const subdirectories = response.data.subdirectories.map((directory) => {
        return {
          label: directory,
          value: directory,
        };
      });

      this.subdirectories = subdirectories;
      return this.subdirectories;
    } catch (error) {
      console.error("Errore durante il recupero delle sottodirectory:", error);
      throw error;
    }
  }

  async getSubDirectorySwitchInNomi() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getSubDirectorySwitchInNomi`;
      const response = await axios.get(url);

      const nomi = response.data.subdirectories.filter(
        (directory) => directory === "POD" || directory === "PDR"
      );

      return nomi;
    } catch (error) {
      console.error(
        "Errore durante il recupero dei nomi delle sottodirectory:",
        error
      );
      throw error;
    }
  }

  async uploadFileLettureOnFtp(file, tipoFornitura = null) {
    let url = `${this.baseUrlFlussi}/letture_distribuzione_ee/upload-file-letture`;
    let fd = new FormData();
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }
    fd.append("email", store.state.auth.user.email);
    fd.append('tipo_fornitura', tipoFornitura);
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }


  async uploadFileLettureOnFtpGas(file, tipoFornitura = null) {
    let url = `${this.baseUrlFlussi}/letture_distribuzione_gas/upload-file-letture`;
    let fd = new FormData();
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }
    fd.append("email", store.state.auth.user.email);
    fd.append('tipo_fornitura', tipoFornitura);
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async getAllUploadedFilesLetture() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFilesLetture`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async uploadFileVT4OnFtp(file) {
    let url = `${this.praticheUrl}/api/switch-management/save/vt4`;
    let fd = new FormData();
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }
    fd.append("email", store.state.auth.user.email);
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async getAllUploadedFilesVT(date) {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFilesVT`;
      const response = await axios.get(url, { params: { data: date } });
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async uploadFileVTG4OnFtp(file) {
    let url = `${this.praticheUrl}/api/switch-management/save/vtg4`;
    let fd = new FormData();
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }
    fd.append("email", store.state.auth.user.email);
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async downloadVtg4(filename) {
    const url = `${this.praticheUrl}/api/switch-management/download/vtg4/file`;
    const fd = new FormData();
    fd.append("filename", filename);

    return axios.post(url, fd, {
      responseType: "blob",
    });
  }

  async uploadFileAnnullamentoPraticaOnFtp(file) {
    let url = `${this.praticheUrl}/api/switch-management/save/annullamento`;
    let fd = new FormData();
    for (let i = 0; i < file.length; i++) {
      fd.append("files[]", file[i]);
    }
    fd.append("email", store.state.auth.user.email);
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async getAllUploadedFilesAnnullamentoPratica() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFilesAnnullamentoPratica`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async generateSwitchoutCacheEE() {

    const url = `${this.praticheUrl}/api/switch-management/generate/switchout/cache/ee`;

    try {
      let res = await axios.get(url);
      this.eventBus.emit("data-load-success", { message: `${res.data.success}` });
      return res.data;
    } catch (error) {
      console.log("Errore durante la sincronizzazione:", error);
      this.eventBus.emit("data-load-error", { message: error, url });
      throw error;
    }
  }

  async generateSwitchoutCacheGas() {

    const url = `${this.praticheUrl}/api/switch-management/generate/switchout/cache/gas`;

    try {
      let res = await axios.get(url);
      this.eventBus.emit("data-load-success", { message: `${res.data.success}` });
      return res.data;
    } catch (error) {
      console.log("Errore durante la sincronizzazione:", error);
      this.eventBus.emit("data-load-error", { message: error, url });
      throw error;
    }
  }

  async sendTestSwitchoutEmailEE() {
    
    const url = `${this.praticheUrl}/api/switch-management/send/switchout/email/ee/test`;

    try {
      let res = await axios.get(url);
      this.eventBus.emit("data-load-success", { message: `${res.data.message} - ${res.data.nSwitchOut}` });
      return res.data;
    } catch (error) {
      console.log("Errore durante l'invio dell'email:", error);
      this.eventBus.emit("data-load-error", { message: error, url });
      throw error;
    }
  }

  async sendTestSwitchoutEmailGas() {
    
    const url = `${this.praticheUrl}/api/switch-management/send/switchout/email/gas/test`;

    try {
      let res = await axios.get(url);
      this.eventBus.emit("data-load-success", { message: `${res.data.message} - ${res.data.nSwitchOut}`});
      return res.data;
    } catch (error) {
      console.log("Errore durante l'invio dell'email:", error);
      this.eventBus.emit("data-load-error", { message: error, url });
      throw error;
    }
  }

  async sendOfficialSwitchoutEmailEE() {
    
    const url = `${this.praticheUrl}/api/switch-management/send/switchout/email/ee/official`;

    try {
      let res = await axios.get(url);
      this.eventBus.emit("data-load-success", { message: `${res.data.message} - ${res.data.nSwitchOut}` });
      return res.data;
    } catch (error) {
      console.log("Errore durante l'invio dell'email:", error);
      this.eventBus.emit("data-load-error", { message: error, url });
      throw error;
    }
  }

  async sendOfficialSwitchoutEmailGas() {
    
    const url = `${this.praticheUrl}/api/switch-management/send/switchout/email/gas/official`;

    try {
      let res = await axios.get(url);
      this.eventBus.emit("data-load-success", { message: `${res.data.message} - ${res.data.nSwitchOut}` });
      return res.data;
    } catch (error) {
      console.log("Errore durante l'invio dell'email:", error);
      this.eventBus.emit("data-load-error", { message: error, url });
      throw error;
    }
  }

  async getListaFornitoriImportati() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getListaFornitoriUploaded`;
      const response = await axios.get(url);

      return response.data.map((item) => ({
        provider: item.provider,
        count: item.count,
        last_modified: item.last_modified,
      }));
    } catch (error) {
      console.error(
        "Errore durante il recupero della lista dei fornitori importati:",
        error
      );
      throw error;
    }
  }

  async getListaFornitoriSplitted() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getListaFornitoriUploadedSplitted`;
      const response = await axios.get(url);
  
      const groupedData = response.data.reduce((acc, item) => {
        if (!acc[item.provider]) {
          acc[item.provider] = {
            EE: { count: 0, last_modified: null, db_count: 0 },
            GAS: { count: 0, last_modified: null, db_count: 0 },
          };
        }
  
        if (item.type === "EE") {
          acc[item.provider].EE.count = item.count;
          acc[item.provider].EE.last_modified = item.last_modified;
          acc[item.provider].EE.db_count = item.db_count; 
        } else if (item.type === "GAS") {
          acc[item.provider].GAS.count = item.count;
          acc[item.provider].GAS.last_modified = item.last_modified;
          acc[item.provider].GAS.db_count = item.db_count; 
        }
        return acc;
      }, {});
  
      const formattedData = Object.keys(groupedData).map((provider) => ({
        provider,
        EE: groupedData[provider].EE.count || 0,
        EE_last_modified: groupedData[provider].EE.last_modified || null,
        EE_db_count: groupedData[provider].EE.db_count || 0, 
        GAS: groupedData[provider].GAS.count || 0,
        GAS_last_modified: groupedData[provider].GAS.last_modified || null,
        GAS_db_count: groupedData[provider].GAS.db_count || 0, 
      }));
  
      return formattedData;
    } catch (error) {
      console.error(
        "Errore durante il recupero della lista dei fornitori splittati:",
        error
      );
      throw error;
    }
  }

  async getMonthlyDataForAllProviders() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getMonthlyDataForAllProviders`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei dati mensili:", error);
      throw error;
    }
  }

  async getListaFornitori() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getListaFornitori`;
      const response = await axios.get(url);
      const fornitori = response.data.fornitori.map((fornitore) => {
        return {
          name: fornitore.name,
          subdirectories: fornitore.subdirectories,
        };
      });
      return fornitori;
    } catch (error) {
      console.error(
        "Errore durante il recupero dell'elenco dei fornitori:",
        error
      );
      throw error;
    }
  }
  

  async getSubDirectorySwitchOut() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getSubDirectorySwitchOut`;
      const response = await axios.get(url);

      const subdirectories = response.data.subdirectories.map((directory) => {
        return {
          label: directory,
          value: directory,
        };
      });

      this.subdirectories = subdirectories;
      return this.subdirectories;
    } catch (error) {
      console.error("Errore durante il recupero delle sottodirectory:", error);
      throw error;
    }
  }

  async getSubDirectorySwitchOutNomi() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getSubDirectorySwitchOutNomi`;
      const response = await axios.get(url);

      const nomi = response.data.subdirectories.filter(
        (directory) => directory === "POD" || directory === "PDR"
      );

      return nomi;
    } catch (error) {
      console.error(
        "Errore durante il recupero dei nomi delle sottodirectory:",
        error
      );
      throw error;
    }
  }

  async getFilesByFornitore(fornitore) {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getFilesByFornitore?fornitore=${fornitore}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error(
        "Errore durante il recupero dei file del fornitore:",
        error
      );
      throw error;
    }
  }

  async getListaFornitoriNomi() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getListaFornitoriNomi`;
      const response = await axios.get(url);
      const fornitoriNomi = response.data.fornitoriNomi;
      return fornitoriNomi;
    } catch (error) {
      console.error(
        "Errore durante il recupero dell'elenco dei nomi dei fornitori:",
        error
      );
      throw error;
    }
  }

  async getContenutoInboxFornitori() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getContenutoInboxFornitori`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async caricaFileFornitore(fornitore, files, sottocartella) {
    try {
      let fornitorePrincipale = fornitore;

      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/caricaFileFornitore`;

      const formData = new FormData();
      formData.append("fornitore", fornitorePrincipale);
      formData.append("sottocartella", sottocartella ? sottocartella : "");

      for (let i = 0; i < files.length; i++) {
        formData.append("files[]", files[i]);
      }

      formData.append("email", store.state.auth.user.email);

      const response = await axios.post(url, formData);

      if (response.data && response.data.message) {
        if (response.data.uploaded_files && response.data.uploaded_files.length > 0) {
          response.data.uploaded_files.forEach(file => {
            if (file.file_path) {
              file.file_path = file.file_path.replace(/\\/g, "");
            }
          });
        }
        return response.data;
      } else {
        throw new Error("Risposta non valida dal server");
      }
    } catch (error) {
      console.error(
        "Errore durante il caricamento del file nella cartella Inbox del fornitore:",
        error
      );
      throw error;
    }
  }

  async getUploadedFilesByFornitore(fornitore) {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getUploadedFilesByFornitore?fornitore=${fornitore}`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error(
        "Errore durante il recupero dei file del fornitore:",
        error
      );
      throw error;
    }
  }

  async handleFornitoreSelected(fornitore) {
    try {
      const files = await this.getUploadedFilesByFornitore(fornitore);
      this.files = files;
    } catch (error) {
      console.error(
        "Errore durante il recupero dei file del fornitore:",
        error
      );
    }
  }

  async getAllUploadedFattureFornitori() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFattureFornitori`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async importEsitoSospensioniRiattivazioniToDatabase(files, subdirectory) {
    let url = `${this.praticheUrl}/api/sospensioni-riattivazioni-management/save/esito`;
    
    let fd = new FormData();
    for (let i = 0; i < files.length; i++) {
      fd.append("files[]", files[i]);
    }
    fd.append("email", store.state.auth.user.email);
    if (subdirectory) {
      fd.append("subdirectory", subdirectory);
    }
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async importRisposteSospensioniRiattivazioniToDatabase(files, subdirectory) {
    let url = `${this.praticheUrl}/api/sospensioni-riattivazioni-management/save/risposte`;
    
    let fd = new FormData();
    for (let i = 0; i < files.length; i++) {
      fd.append("files[]", files[i]);
    }
    fd.append("email", store.state.auth.user.email);
    if (subdirectory) {
      fd.append("subdirectory", subdirectory);
    }
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async importTrackingSospensioniRiattivazioniToDatabase(files, subdirectory) {
    let url = `${this.praticheUrl}/api/sospensioni-riattivazioni-management/save/tracking`;
    
    let fd = new FormData();
    for (let i = 0; i < files.length; i++) {
      fd.append("files[]", files[i]);
    }
    fd.append("email", store.state.auth.user.email);
    if (subdirectory) {
      fd.append("subdirectory", subdirectory);
    }
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async generateSospensioniRiattivazioniPodCache() {
    let items = {};
    let url = `${this.praticheUrl}/api/sospensioni-riattivazioni-management/generate/sosp-riat/cache`;
  
    try {
      const res = await axios.get(url);
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
    }
  
    return { items };
  }  

   async aggiornaStatiSospensioniRiattivazioni() {
    let items = {};
    let url = `${this.praticheUrl}/api/sospensioni-riattivazioni-management/aggiorna-stati`;
  
    try {
      const res = await axios.get(url);
      items = res.data;
    } catch (err) {
      console.log("messaggio errore", err.response.data.message);
      throw err.response.data.message;
    } finally {
      this.eventBus.emit("data-loaded");
    }
  
    return { items };
  }

  async uploadFileSospensioniERiattivazioniOnFtp(files, subdirectory) {
    let url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/uploadFileSospensioniERiattivazioni`;
    let fd = new FormData();
    for (let i = 0; i < files.length; i++) {
      fd.append("files[]", files[i]);
    }
    fd.append("email", store.state.auth.user.email);
    if (subdirectory) {
      fd.append("subdirectory", subdirectory);
    }
    let res = await axios({
      url,
      method: "POST",
      data: fd,
    });
    return res.data;
  }

  async getAllUploadedFilesSospensioniERiattivazioni() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getAllUploadedFilesSospensioniERiattivazioni`;
      const response = await axios.get(url);
      return response.data.files;
    } catch (error) {
      console.error("Errore durante il recupero dei file:", error);
      throw error;
    }
  }

  async getSubDirectorySospensioniERiattivazioni() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getSubDirectorySospensioniERiattivazioni`;
      const response = await axios.get(url);

      const subdirectories = response.data.subdirectories.map((directory) => {
        return {
          label: directory,
          value: directory,
        };
      });

      this.subdirectories = subdirectories;
      return this.subdirectories;
    } catch (error) {
      console.error("Errore durante il recupero delle sottodirectory:", error);
      throw error;
    }
  }

  async getSubDirectorySospensioniERiattivazioniNomi() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getSubDirectorySospensioniERiattivazioniNomi`;
      const response = await axios.get(url);

      const nomi = response.data.subdirectories;

      return nomi;
    } catch (error) {
      console.error(
        "Errore durante il recupero dei nomi delle sottodirectory:",
        error
      );
      throw error;
    }
  }

  async getLogsFattureAgyo(startDate, endDate) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getLogsFattureAgyo`;
    try {
      const res = await axios.get(url, {
        params: {
          startDate,
          endDate
        }
      });
      return res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
  }




  async getInvoiceByNumber(numero) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getLogFatturaByNumero`;
    try {
      const res = await axios.get(url, {
        params: {
          numero,  
        }
      });
      return res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
}


  async getLogsFattureAgyoErrore() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getLogsFattureAgyoErrore`;
    try {
      const res = await axios.get(url, {
        params: {
          
        }
      });
      return res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
  }

  async inviaFattureErroreViaEmail(fattureErrore) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/inviaFattureErroreViaEmail`;
  
    try {
      const res = await axios.post(url, { 
        fattureErrore: fattureErrore  
      }, {
        headers: {
          'Content-Type': 'application/json'  
        }
      });
      
      return res.data;
    } catch (err) {
      throw new Error(`Errore durante l'invio delle fatture errore: ${err.message}`);
    }
}


  async getFattureVuote() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/recuperaFattureVuote`;
    try {
      const res = await axios.get(url);
      return res.data.data; 
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
  }


  async getFattureDaRinviareCount() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/checkFattureDaRinviarePerFrontend`;
    try {
      const res = await axios.get(url);
      return res.data.data; 
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
  }


  async InviaFatturaAgyoFromFile(numero) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/InviaFatturaAgyoFromFile`;
    try {
      const res = await axios.get(url, { params: { numero } });
      return res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
  }
  
  


  async uploadFileRcuOnFtpAndDB(formData) {
    let url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/uploadRcuForDb`;
    let res = await axios({
      url,
      method: "POST",
      data: formData,
    });
    return res.data;
  }

  async getUploadedFiles() {
    let url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getUploadedFiles`;
    let res = await axios.get(url);
    return res.data;
  }


  async updateFileDossier(type) {
    let items = {};
    const url = `${this.baseUrl}/process/agf/file/updateFileDossier`;
    try {
      const res = await axios.post(url, { type });
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async test(type) {
    let items = {};
    const url = `${this.baseUrlApi}/process/agf/file/updateFileDossier`;
    try {
      const res = await axios.post(url, { type });
      items = res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
    } finally {
      this.eventBus.emit("data-loaded");
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }


  /**
   * Log SendGrid di un indirizzo: una pagina di messaggi, invii ASK o eventi
   * grezzi, con il riepilogo dell'indirizzo quando richiesto.
   * Gli errori vengono rilanciati: la pagina li mostra inline, senza toast.
   */
  async findLogByEmail(params) {
    const url = `${this.baseUrlFlussi}/sendgrid/email`;
    const response = await axios.post(url, params);
    return response.data?.data ?? null;
  }

  /** Autocomplete degli indirizzi presenti nei log SendGrid. */
  async suggestSendgridEmail(q, limit = 8) {
    const url = `${this.baseUrlFlussi}/sendgrid/suggest`;
    const response = await axios.get(url, { params: { q, limit } });
    return response.data?.data ?? [];
  }

  /** Tutti gli eventi di un singolo messaggio SendGrid. */
  async getSendgridMessageEvents(email, sgMessageId) {
    const url = `${this.baseUrlFlussi}/sendgrid/message`;
    const response = await axios.post(url, { email, sg_message_id: sgMessageId });
    return response.data?.data ?? [];
  }

  async getListaFileFornitore(provider) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getListaFileFornitore`; 
    try {
        const response = await axios.get(url, {
            params: { provider } 
        });
        return response.data;
    } catch (error) {
        console.error("Errore durante il recupero della lista file:", error);
        throw error;
    }
}


async downloadFileFromFornitore(provider, fileName) {
  const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/downloadFileFornitore`;
  try {
      const response = await axios.get(url, {
          params: { provider, fileName }, 
          responseType: 'blob', 
      });

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', fileName); 
      document.body.appendChild(fileLink);

      fileLink.click(); 
      document.body.removeChild(fileLink);

  } catch (error) {
      console.error("Errore durante il download del file:", error);
      throw error;
  }
}

  async viewFileFornitore(fileName) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/visualizzaFileFornitore`;
    try {
      const response = await axios.get(url, { params: { fileName } });
      return response; 
    } catch (error) {
      console.error("Errore nella chiamata API:", error);
      throw error;
    }
  }

  async getFornitoriFattureMancantiEE() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getFornitoriFattureMancantiEE`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore nel recupero dei fornitori EE:", error);
      throw error;
    }
  }
  
  async getFornitoriFattureMancantiGAS() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getFornitoriFattureMancantiGAS`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore nel recupero dei fornitori GAS:", error);
      throw error;
    }
  }
  
  async getDettaglioFattureFornitore(codFornitore) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getDettaglioFattureFornitore`;
    try {
      const response = await axios.get(url, {
        params: { cod_fornitore: codFornitore }
      });
      return response.data;
    } catch (error) {
      console.error("Errore nel recupero delle fatture:", error);
      throw error;
    }
  }

  async sincronizzaSwin() {
    const url = `${this.baseUrl}/process/agf/file/sincronizza-swin`;
    
    try {
      const response = await axios.get(url);
      return response;
    } catch (error) {
      console.error('Errore nella chiamata GET:', error.message);
    }
  }

  async getCountFattureAgyo(mese) {
    const url = `${this.baseUrl}/getCountFattureAgyo/${mese}`;
    try {
      const res = await axios.get(url);
      return res.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
  }

  async getCheckFatture() {
    const url = `${this.baseUrl}/checkFatturaAgyoTotale`;
    try {
      const res = await axios.get(url);
      return res.data;
    } catch (err) {
      if (err.response && err.response.status === 404) {
        return [];
      }
      this.eventBus.emit("data-load-error", { message: err.message, url });
      throw err;
    }
  }

  async uploadRcuDatiEnergia(formData) {
    let url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/uploadRcuDatiEnergia`;
    let res = await axios({
      url,
      method: "POST",
      data: formData,
    });
    return res.data;
  }

  async importRcuGasData(monthYear) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/importRcuGasData`;
    try {
      const response = await axios.get(url, {
        params: {
          mese: monthYear
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione dei dati RCU Gas:", error);
      throw error;
    }
  }

  async importRcuEEData(monthYear) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/importRcuEEData`;
    try {
      const response = await axios.get(url, {
        params: {
          mese: monthYear
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione dei dati RCU EE:", error);
      throw error;
    }
  }

  async getImportStatusCheckRcuDati() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getImportStatusCheckRcuDati`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) { 
      console.error("Errore durante il recupero dello stato di importazione:", error);
      throw error;
    }
  }

  async getSubDirectoryFattureGrezzeFornitori() {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getSubDirectoryFattureGrezzeFornitori`;
      const response = await axios.get(url);
      
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero delle directory per fatture grezze:", error);
      throw error;
    }
  }
  
  async importFattureGrezzeFornitori(formData) {
    try {
      const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/importFattureGrezzeFornitori`;
      
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value instanceof File ? value.name : value}`);
      }

      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data && response.data.message) {
        if (response.data.file_path) {
          const filePathWithoutEscape = response.data.file_path.replace(/\\/g, "");
          response.data.file_path = filePathWithoutEscape;
        }
        return response.data;
      } else {
        throw new Error("Risposta non valida dal server");
      }
    } catch (error) {
      console.error("Errore durante il caricamento delle fatture grezze:", error);
      throw error;
    }
  }

  async getTimoePathsFtp() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/getTimoePathsFtp`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore nel recupero dei percorsi TIMOE:", error);
      throw error;
    }
  }
  
  async importTimoeFilesFtp(files) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/importTimoeFilesFtp`;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i]);
    }
  
    try {
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione dei file TIMOE:", error);
      throw error;
    }
  }

  async importTimoeEEFilesDatabase() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/import-timoe-ee-database`;
    try {
      const response = await axios.post(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione TIMOE EE nel database:", error);
      throw error; 
    }
  }

  async importTimgGasFilesDatabase() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/import-timg-gas-database`;
    try {
      const response = await axios.post(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione TIMG GAS nel database:", error);
      throw error; 
    }
  }


  async getImportedFilesCountTimoe() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/imported-files-count`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero dei file importati:", error);
      throw error;
    }
  }

  async getTimoeDataByCode(code) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/get-timoe-data`;
    try {
      const response = await axios.get(url, {
        params: { code }
      });
      return response.data; 
    } catch (error) {
      console.error("Errore durante il recupero dei dati TIMOE/TIMG per codice:", error);
      throw error; 
    }
  }

  async uploadNotificaIndennizzo(formData) {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/uploadNotificaIndennizzo`;
    try {
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il caricamento della notifica indennizzo:", error);
      throw error;
    }
  }

  async importNotificaIndennizzo() {
    const url = `${this.baseUrlApi}/AreaFlussi/caricamento-flows/importNotificaIndennizzo`;
    try {
      const response = await axios.post(url);
      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione della notifica indennizzo:", error);
      throw error;
    }
  }

  async checkRcuData(selectedDate = null, { details = true, detailsOnly = false } = {}) {
    const url = `${this.baseUrlFlussi}/automatizzazioni/browser/processRcuValidation`;
    try {
      const params = {
        details: details ? 1 : 0,
      };
      if (detailsOnly) {
        params.details_only = 1;
      }
      if (selectedDate) {
        params.date = selectedDate;
      }

      // Timeout alto: i dettagli POD/PDR possono richiedere più tempo del default axios
      const response = await axios.get(url, {
        params,
        timeout: details ? 180000 : 60000,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il controllo dei dati RCU:", error);
      throw error;
    }
  }

  async getRcuMonthlyPresence(months = 18) {
    const url = `${this.baseUrlFlussi}/automatizzazioni/browser/rcuMonthlyPresence`;
    try {
      const response = await axios.get(url, {
        params: { months },
        timeout: 60000,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero presenza RCU mensile:", error);
      throw error;
    }
  }

  async existNotElaboratedAccettazione() {
    const url = `${this.praticheUrl}/api/get-exist-not-elaborated-accettazione`;

    try {
      const { data } = await axios.get(url);
      return data;
    } catch (error) {
      console.error("Errore existNotElaboratedAccettazione:", {
        message: error?.message,
        status: error?.response?.status,
        data: error?.response?.data,
      });
      throw error;
    }
  }
  async getAllTypesDocumenti() {
    const url = `${this.baseUrlApi}/document-version/get-all-types-documenti`;

    try {
      const res = await axios.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async storeNuovaVersione(formData) {
    const url = `${this.baseUrlApi}/document-version/uploadNuovaVersione`;
    try {
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il salvataggio della nuova versione del documento:", error);
      throw error;
    }
  }

  async getStoricoVersioni(){
    const url = `${this.baseUrlApi}/document-version/get-versioni-documenti`;

    try {
      const res = await axios.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async downloadFileVersione(id) {
    const url = `${this.baseUrlApi}/document-version/download-file-versione`;
  
    let res = await axios.post(url, { id }, { responseType: "blob" });
    this.filemanager.download(res)
  }  
}

